import { render, staticRenderFns } from "./loss-box.vue?vue&type=template&id=712c552e&scoped=true&"
import script from "./loss-box.vue?vue&type=script&lang=js&"
export * from "./loss-box.vue?vue&type=script&lang=js&"
import style0 from "./loss-box.vue?vue&type=style&index=0&id=712c552e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c552e",
  null
  
)

export default component.exports